import { Box, debounce } from '@mui/material'
import { LoopIcon } from 'images'
import React, { useMemo } from 'react'
import { ControlsWrapper } from './FilterControls.styled'
import { useSearchApprovedContext } from 'pages/approve/context/SearchApprovesContext'
import { IdNameItem, MultiAutoSuggest } from 'core/ui/MultiAutoSuggest'
import { TextField } from 'core'
import { levelsNames} from 'utils/enums/different'
import _ from 'lodash'

const convertOptionsToValues: (items: IdNameItem[]) => string[] = (items) => items.map((i) => i.name)

const convertValuesToOptions: (values: string[]) => IdNameItem[] = (values) =>
    values.map((val) => ({
        id: val,
        name: val,
    }))

export const FilterControls = () => {
    const {
        fetchedCompetencies,
        competencies,
        setCompetencies,
        setSearchString,
        setNewLevels,
        newLevels,
        searchString,
        results,
    } = useSearchApprovedContext()

    const handleSearchStringChange = debounce((e) => {
        setSearchString(e.target?.value)
    }, 500)

    const levelsToShow = levelsNames.slice(3);

    return useMemo(() => {
        return (
            <ControlsWrapper>
                <Box component="div" sx={{ width: '360px' }}>
                    <TextField
                        id="search-input"
                        value={searchString}
                        placeholder="Search"
                        fullWidth={true}
                        InputProps={{
                            startAdornment: <LoopIcon />,
                        }}
                        clearable={true}
                        onChange={handleSearchStringChange}
                    />
                </Box>

                <Box component="div" sx={{ width: '230px' }}>
                    <MultiAutoSuggest<IdNameItem>
                        id="levels-filter"
                        label={'New Level'}
                        options={convertValuesToOptions(levelsToShow || [])}
                        value={convertValuesToOptions(newLevels.map((i) => levelsNames[i-1]))}
                        onChange={(selected: IdNameItem[]) => {
                            setNewLevels(selected.map((i) => levelsNames.indexOf(i.id)+1))
                        }}
                        renderTags={() => ''}
                        componentsProps={{
                            paper: {
                                sx: {
                                    width: '500px',
                                },
                            },
                        }}
                    />
                </Box>

                <Box component="div" sx={{ width: '221px' }}>
                    <MultiAutoSuggest<IdNameItem>
                        id="competencies-filter"
                        label={'Business unit'}
                        options={convertValuesToOptions(fetchedCompetencies || [])}
                        value={convertValuesToOptions(competencies)}
                        onChange={(selectedCompetencies: any) => {
                            setCompetencies(convertOptionsToValues(selectedCompetencies))
                        }}
                        renderTags={() => ''}
                        componentsProps={{
                            paper: {
                                sx: {
                                    width: '500px',
                                },
                            },
                        }}
                    />
                </Box>
            </ControlsWrapper>
        )
    }, [
        fetchedCompetencies,
        competencies,
        setCompetencies,
        newLevels,
        setNewLevels,
        searchString,
        setSearchString,
        results,
    ])
}
